export enum EmailTemplateType {
  MARKETING = 'MARKETING',
  INFORMATIONAL = 'INFORMATIONAL',
  SYSTEM_ALERT = 'SYSTEM_ALERT',
  NEW_ASSESSMENT = 'NEW_ASSESSMENT',
  COMPLETED_ASSESSMENT = 'COMPLETED_ASSESSMENT',
}

export class EmailTemplate {
  public id?: number;
  public type?: EmailTemplateType;
  public theme?: string;
  public subject?: string;
  public sender?: string;
  public htmlBody?: string;
  public textBody?: string;

  constructor(obj: EmailTemplate = {} as EmailTemplate) {
    this.id = obj.id;
    this.theme = obj.theme;
    this.type = obj.type;
    this.subject = obj.subject;
    this.sender = obj.sender;
    this.htmlBody = obj.htmlBody;
    this.textBody = obj.textBody;
  }
}